import React from 'react';
import { AlertCircle } from 'lucide-react';

const LimitModal = ({ isOpen, onClose, onProvideFeedback }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-lg w-full mx-4">
        <div className="text-center mb-6">
          <div className="bg-red-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
            <AlertCircle className="text-red-600" size={32} />
          </div>
          <h3 className="text-2xl font-semibold text-gray-900 mb-2">Assessment Limit Reached</h3>
          <p className="text-gray-600">You've used all of your available assessments.</p>
        </div>
        
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
          <h4 className="font-semibold text-blue-900 mb-2">Need More Assessments?</h4>
          <p className="text-blue-800 text-sm mb-3">
            Help us improve by providing feedback on your experience. We'll review your input and can provide additional assessment credits.
          </p>
          <ul className="text-blue-800 text-sm space-y-1 ml-4">
            <li>• Share your thoughts on accuracy</li>
            <li>• Suggest improvements</li>
            <li>• Report any issues</li>
          </ul>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 bg-gray-300 text-gray-700 py-3 rounded-lg font-semibold hover:bg-gray-400"
          >
            Close
          </button>
          <button
            onClick={() => {
              onClose();
              onProvideFeedback();
            }}
            className="flex-1 bg-teal-600 text-white py-3 rounded-lg font-semibold hover:bg-teal-700"
          >
            Provide Feedback
          </button>
        </div>
      </div>
    </div>
  );
};

export default LimitModal;

